import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
            Guides & SEO Artikel
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Alles über OOPBuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Schritt-für-Schritt-Tutorials und Guides, die dir helfen, smarter auf OOPBuy zu shoppen.
          </p>
        </div>

        {/* Article Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <a
              key={article.id}
              href={`/article/${article.slug}`}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 hover:shadow-sm"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300" />
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700">
                  <span>Weiterlesen</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}